'use strict';

/**
 * Toggles the visibility of the clear/cross icon based on
 * whether the associated input field contains a value.
 *
 * @param {jQuery} $input - The input field jQuery object.
 */
function toggleCrossIcon($input) {
    const $icon = $input.siblings('py-cross-right.bl-cross');
    $icon.toggleClass('d-none', !$input.val().trim().length);
}

/**
 * Validates all required form fields and enables/disables
 * the submit button accordingly.
 * @returns {void}
 */
function toggleSubmitButton() {
    const $submitBtn = $('.blog-submit');
    const fullNameValue = $('.blfullname-field').val().trim();
    const phoneValue = $('.blog-mobile-input').val().trim();
    const emailValue = $('.blemail-field').val().trim();

    const isValid = fullNameValue.length > 0
        && phoneValue.length === 10
        && /^[0-9]+$/.test(phoneValue)
        && /^(?!.*\.\.)[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);

    $submitBtn.prop('disabled', !isValid);
}

/**
 * Sanitizes and validates an Indian mobile number.
 *
 * @param {string} value - Raw input value.
 * @returns {string} Sanitized mobile number.
 */
function validatePhoneInput(value) {
    let sanitized = value.replace(/\D/g, '');

    if (sanitized.length > 0) {
        const firstDigit = sanitized.charAt(0);

        if (!['6', '7', '8', '9'].includes(firstDigit)) {
            return '';
        }
    }

    return sanitized.substring(0, 10);
}

$('.blfullname-field').on('input', function () {
    const $this = $(this);
    let value = $this.val();
    let regx = /^(?! )[A-Za-z]+(?: [A-Za-z]+)*$/;

    if (!regx.test(value)) {
        value = value.replace(/[^A-Za-z ]/g, '')
            .replace(/^\s+/, '')
            .replace(/\s{2,}/g, ' ');
        $this.val(value);
    }

    toggleCrossIcon($this);
    toggleSubmitButton();
});

// Phone input validation
$('.blog-mobile-input').on('input', function () {
    const $this = $(this);
    const validatedValue = validatePhoneInput($this.val());
    $this.val(validatedValue);
    toggleCrossIcon($this);
    toggleSubmitButton();
});

$('.blemail-field').on('input', function () {
    const $this = $(this);
    const value = $this.val()
        .replace(/[^\w@.-]/g, '') // remove invalid chars
        .replace(/\.{2,}/g, '.');

    $this.val(value);
    toggleCrossIcon($this);
    toggleSubmitButton();
});

$('.blog-form').on('submit', function (e) {
    e.preventDefault();
    const $form = $(this);
    const url = $('.blog-submit').data('action');
    const formData = $form.serialize();
    $.spinner().start();
    $.ajax({
        type: 'POST',
        url: url,
        data: formData,
        success: (response) => {
            if (response.success) {
                $('body').trigger('successToast', 'Thanks for reaching out to us!');
                $form[0].reset();
                $form.find('input, textarea, select').removeClass('has-value');
                $('.py-cross-right.bl-cross').addClass('d-none');
                $('.blog-submit').prop('disabled', true);
            } else {
                $('body').trigger('failureToast', 'Something went wrong. Please try again later.');
            }
            $.spinner().stop();
        },
        error: () => {
            $.spinner().stop();
        }
    });
});
